import React from 'react'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

export class GraphicWeek extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      firstView: false,
      secondView: false,
      isMobile: window.innerWidth < 768
    }
  }

  componentDidMount() {
    setTimeout(
      function() {
        this.setState({ firstView: true })
        this.setState({ secondView: true })
      }.bind(this),
      1000
    )
  }

  render() {
    return (
      <div className='graphicweek'>
        <div className='wrapper'>
          <h2 style={{ marginTop: 0 }}>Pro Woche</h2>
          <img
            src={require('./image/week.jpg')}
            className={
              this.state.firstView ? 'ui fluid image active' : 'ui fluid image'
            }
          />
          <div
            className={
              this.state.secondView ? 'annotation active' : 'annotation'
            }
          >
            <div className='contain'>
              <div className='amount'>5 Gramm</div>
              <img src={require('./image/arrow.svg')} className='arrow' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GraphicWeek
